import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import StaffDashboard from './components/StaffDashboard';
import DashboardHome from './components/DashboardHome';
import DogManagement from './components/DogManagement';
import RiskMatrix from './components/RiskMatrix';
import LiveStream from './components/LiveStream';
import MissingDogWall from './components/MissingDogWall';
import UserManagement from './components/UserManagement';
import TaskManagement from './components/TaskManagement';
import Alerts from './components/Alerts';
import FoundReports from './components/FoundReports';
import Reports from './components/Reports';
import WallReports from './components/WallReports';
import LaunchGate from './components/LaunchGate';
import './App.css';

function ProtectedRoute({ children, user }) {
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function PublicRoute({ children, user }) {
  if (user) {
    return <Navigate to="/staff/dashboard" replace />;
  }
  return children;
}

function App() {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route 
          path="/login" 
          element={
            <PublicRoute user={user}>
              <Login onLogin={handleLogin} />
            </PublicRoute>
          } 
        />
        
        <Route
          path="/"
          element={
            <LaunchGate user={user}>
              <MissingDogWall />
            </LaunchGate>
          }
        />
        <Route
          path="/missing-wall"
          element={
            <LaunchGate user={user}>
              <MissingDogWall />
            </LaunchGate>
          }
        />
        
        <Route
          path="/staff"
          element={
            <ProtectedRoute user={user}>
              <StaffDashboard user={user} onLogout={handleLogout} />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<DashboardHome currentUser={user} />} />
          <Route path="dogs" element={<DogManagement currentUser={user} />} />
          <Route path="risk-matrix" element={<RiskMatrix currentUser={user} />} />
          <Route path="alerts" element={<Alerts currentUser={user} />} />
          <Route path="found-reports" element={<FoundReports currentUser={user} />} />
          <Route path="reports" element={<Reports currentUser={user} />} />
          <Route path="wall-reports" element={<WallReports currentUser={user} />} />
          <Route path="stream" element={<LiveStream />} />
          <Route path="users" element={<UserManagement currentUser={user} />} />
          <Route path="tasks" element={<TaskManagement currentUser={user} />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
